import { Box } from '@mui/material';
import makeStyles from '@mui/styles/makeStyles';
import { insuranceSelector } from '../../../model';
import { useSelector } from 'react-redux';

import { CertificateUploaded } from './CertificateUploaded';
import { NoCertificate } from './NoCertificate';

export const CertificateOfInsurance = () => {
  const classes = useStyles();

  const insuranceCertificate = useSelector(insuranceSelector.insuranceCertificate);

  return <Box className={classes.root}>{insuranceCertificate ? <CertificateUploaded /> : <NoCertificate />}</Box>;
};

const useStyles = makeStyles({
  root: {
    backgroundColor: '#FAFAFA',
    padding: '24px',
  },
});
